(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  // Checked live inside the handlers (not just once at load) â€” some
  // hybrid devices (touchscreen laptops, tablets with a trackpad) report
  // "hover: hover" as true even while showing the narrow mobile layout,
  // and a window resize can cross the breakpoint too. Re-checking on
  // every move guarantees the cursor-follow drift never applies there,
  // regardless of what the device claims about hover support.
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var MAX_SHIFT = 14; // px, how far the images can drift toward the cursor
  var ZOOM_SCALE = 1.08;

  if (canHover) {
    document.querySelectorAll('[data-recipes-lola-card]').forEach(function (card) {
      var images = card.querySelectorAll('.recipes-lola__image');

      card.addEventListener('mouseenter', function () {
        if (mobileQuery.matches) return;
        card.classList.add('is-hovered');
      });

      card.addEventListener('mousemove', function (event) {
        if (mobileQuery.matches) return;

        var rect = card.getBoundingClientRect();
        var relX = (event.clientX - rect.left) / rect.width - 0.5;
        var relY = (event.clientY - rect.top) / rect.height - 0.5;
        var tx = relX * MAX_SHIFT * 2;
        var ty = relY * MAX_SHIFT * 2;

        images.forEach(function (img) {
          img.style.transform = 'translate(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px) scale(' + ZOOM_SCALE + ')';
        });
      });

      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-hovered');
        images.forEach(function (img) {
          img.style.transform = '';
        });
      });
    });
  }

  document.querySelectorAll('[data-recipes-lola]').forEach(function (section) {
    initMobileSlider(section);
  });

  function initMobileSlider(section) {
    var grid = section.querySelector('[data-recipes-lola-grid]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-recipes-lola-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-recipes-lola-dot]'));

    if (!grid || !slides.length || !dots.length) return;

    var ticking = false;
    var activeIndex = 0;

    function setActiveDot(index) {
      if (index === activeIndex && dots[index].classList.contains('is-active')) return;
      activeIndex = index;
      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    // Whichever slide's center is closest to the grid's own visual
    // center becomes the "active" one â€” this tracks the scroll-snap
    // position without needing IntersectionObserver thresholds tuned per
    // card width.
    function updateActiveFromScroll() {
      if (!mobileQuery.matches) {
        ticking = false;
        return;
      }

      var gridRect = grid.getBoundingClientRect();
      var gridCenter = gridRect.left + gridRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(slideCenter - gridCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      setActiveDot(closestIndex);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateActiveFromScroll);
        ticking = true;
      }
    }

    grid.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateActiveFromScroll();

    // Clicking a dot scrolls that recipe's card into view, centered â€”
    // matching the same scroll-snap alignment the slides already use.
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var slide = slides[index];
        if (!slide) return;
        slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        setActiveDot(index);
      });
    });
  }
})();
